export interface PreviewDocumentModel {
  eventId?: number;
  fileName?: string;
  fileURL?: string;
  documentType?: string;
  readonly apiUri: string;
}

export class EventPoeDocument implements PreviewDocumentModel {
  eventId?: number;
  fileName?: string;
  fileURL?: string;
  documentType?: string;
  readonly apiUri: string;

  constructor() {
    this.apiUri = 'api/EventDetails/DownloadFileSASUrl';
  }
}
